import React, { useState } from 'react'
import { ImageEditableProps } from './ImageEditable.types'
import styles from './ImageEditable.module.scss'
import cl from 'classnames'
import { ImagePortrait } from '../ImagePortrait'
import { IconDeleteCircle, IconMenuDots, IconEditCropping } from 'assets'
import { Button } from '../Button'
import { getImageIndications } from './ImageEditable.utils'
import { SettingIndication } from './SettingIndication'
import { AspectTypes } from 'models'

const ImageEditableComponent = (props: ImageEditableProps) => {
  const {
    galleryImage,
    openImageEditor,
    saveOriginalDimensions,
    removeItem
  } = props

  const [showOptions, setShowOptions] = useState(false)

  const indications = getImageIndications(galleryImage)

  return (
    <div
      className={styles.container}
      onMouseLeave={() => setShowOptions(false)}
    >
      <ImagePortrait
        src={galleryImage.src as string}
        width={161}
        saveOriginalDimensions={saveOriginalDimensions}
      />

      <div className={styles.indications}>
        {indications.squareCrop && (
          <SettingIndication
            label={AspectTypes.SQUARE}
          />
        )}
        {indications.portraitCrop && (
          <SettingIndication
            label={AspectTypes.PORTRAIT}
          />
        )}
      </div>

      <div
        className={cl(styles.optionsContainer, {
          [styles.optionsVisible]: showOptions
        })}
      >

        <Button
          preset='icon'
          disabled={!showOptions}
          onClick={removeItem}
          title='Remove image'
        >
          <IconDeleteCircle fill={styles.white} />
        </Button>
        <Button
          preset='icon'
          disabled={!showOptions}
          onClick={openImageEditor}
          title='Open image editor'
        >
          <IconEditCropping fill={styles.white} />
        </Button>

      </div>
      <IconMenuDots
        className={styles.triggerOptionsIcon}
        onMouseEnter={() => setShowOptions(true)}
      />
    </div>
  )
}

const ImageEditable = ImageEditableComponent
export { ImageEditable }
